/**
 * Outfame Brand Constants
 *
 * Centralized branding configuration for the Outfame platform.
 * Use these constants throughout the codebase for consistent branding.
 */

export const BRAND = {
    name: "Outfame",
    legalName: "Outfame Inc.",
    domain: "outfame.com",
    url: "https://www.outfame.com",
    supportEmail: "support@outfame.com",
    /** AI voice agent toll-free number (empty = hidden from all UI surfaces) */
    supportPhone: "+1 (888) 219-3263" as string,
    /** Existing Quo.com corporate line */
    corporatePhone: "+1 (616) 800-8817",
    tagline: "#1 AI-Powered Instagram Growth",
    description: "Best Instagram & TikTok Growth Service in 2026. Get real followers with AI-powered targeting for 10x faster organic growth."
} as const

/**
 * Social Media Links
 */
export const SOCIAL = {
    instagram: "https://www.instagram.com/outfame.app",
    twitter: "https://x.com/OutfameApp",
    threads: "https://www.threads.com/@outfame.app",
    pinterest: "https://www.pinterest.com/outfameapp",
    linkedin: "https://www.linkedin.com/company/outfame",
    tiktok: "https://www.tiktok.com/@outfame.com",
    youtube: "https://www.youtube.com/@Outfame-com",
    facebook: "https://www.facebook.com/profile.php?id=100090325338527",
    crunchbase: "https://www.crunchbase.com/organization/outfame",
    f6s: "https://www.f6s.com/outfame",
    capterra: "https://www.capterra.com/p/10036225/Outfame/",
    getapp: "https://www.getapp.com/all-software/a/outfame/"
} as const

/**
 * Design System Colors (mirrors Tailwind config)
 * Use for programmatic access when Tailwind classes aren't available
 */
export const COLORS = {
    pink: {
        DEFAULT: "#ffa3d1",
        light: "#ffdbed",
        dark: "#ff82c0"
    },
    purple: {
        DEFAULT: "#c08cf2",
        light: "#f3dbff"
    },
    cream: "#f6f6f4",
    sand: {
        DEFAULT: "#cfc4af",
        light: "#ebe9e0"
    },
    ink: "#141414"
} as const

/**
 * Typography (mirrors Tailwind config)
 */
export const FONTS = {
    display: "Mosans",
    body: "var(--font-dashboard), ui-sans-serif, system-ui, sans-serif"
} as const

/**
 * Meta Information for SEO
 */
export const META = {
    title: "Outfame - #1 AI-Powered Instagram Growth",
    titleTemplate: "%s | Outfame",
    description: "Best Instagram & TikTok Growth Service in 2026. Get real followers with AI-powered targeting for 10x faster organic growth.",
    keywords: ["instagram growth service", "instagram automation", "get instagram followers", "tiktok growth service", "organic instagram growth", "real instagram followers"],
    ogImage: "https://www.outfame.com/api/images/og",
    twitterHandle: "@OutfameApp"
} as const

/**
 * App Store Links (if applicable)
 */
export const APP_LINKS = {
    ios: null, // Add when available
    android: null // Add when available
} as const

/**
 * Aggregate Rating (single source of truth for JSON-LD)
 *
 * Used across all pages that define Product/SoftwareApplication structured data.
 * MUST be identical everywhere to avoid Google's "multiple aggregate ratings" error.
 */
export const AGGREGATE_RATING = {
	"@type": "AggregateRating" as const,
	worstRating: "1",
	bestRating: "5",
	ratingValue: "4.98",
	ratingCount: "1585",
} as const
